store.admin.categories = {};
store.admin.categories.initSort = function() {
	var $form = $('#categorySortForm');
	var $sort = $('#categoriesSort');
	var $divs = $sort.find('li div');
	$sort.bind("sortupdate", function(){
		store.admin.altRow($divs);
		$('#'+moya.message.divId).html('');
	}).trigger('sortupdate');
	$form.submit(function(){
		var d = $("#categoriesSort").nestedSortable("serialize");
		$form.find('#csData').val(d);
		return true;
	});
};
